// extracted by mini-css-extract-plugin
export default {"botAction":"styles_botAction__iQ5Ps"};